<template>
  <div class="banner-carousel">
    <swiper class="inner-swiper" v-bind:options="bannerOption">
      <swiper-slide v-for="(img, i) in bannerImages" :key="i">
        <div class="image-container">
          <!-- 第一张图片立即加载 -->
          <img 
            v-if="i === 0" 
            :src="img" 
            alt="banner" 
            @load="onFirstImageLoad"
          />
          <!-- 其他图片懒加载 -->
          <img 
            v-else-if="shouldLoadImage(i)"
            :src="img" 
            alt="banner" 
            @load="onImageLoad(i)"
          />
          <!-- 加载占位符 -->
          <div v-else class="image-placeholder">
            <div class="loading-spinner"></div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination banner-pagination" slot="pagination"></div>
    </swiper>
    <div class="scroll-more">
      <span class="mouse">
        <i class="dot"></i>
      </span>
      <p class="label">滑动查看更多</p>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Banner",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      bannerImages: [
        // require("../../assets/img/banner1.png"),
        // require("../../assets/img/banner2.png"),
        // require("../../assets/img/banner3.png"),
        // require("../../assets/img/banner4.png")
      ],
      // 图片加载状态管理
      imageLoadStates: [],
      firstImageLoaded: false,
      bannerOption: {
        direction: "horizontal",
        loop: true,
        autoplay: {
          delay: 30000,
          disableOnInteraction: false
        },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".banner-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true
      }
    };
  },
  methods: {
    // 判断是否应该加载指定索引的图片
    shouldLoadImage(index) {
      // 第一张图片总是加载
      if (index === 0) return true;
      // 第一张图片加载完成后，其他图片可以加载
      return this.firstImageLoaded;
    },
    
    // 第一张图片加载完成
    onFirstImageLoad() {
      this.firstImageLoaded = true;
      this.$nextTick(() => {
        // 第一张图片加载完成后，开始加载其他图片
        this.loadRemainingImages();
      });
    },
    
    // 其他图片加载完成
    onImageLoad(index) {
      this.$set(this.imageLoadStates, index, 'loaded');
    },
    
    // 加载剩余图片
    loadRemainingImages() {
      // 触发响应式更新，让其他图片开始加载
      this.$forceUpdate();
    },
    
    // 初始化图片加载状态
    initImageLoadStates() {
      this.imageLoadStates = this.bannerImages.map(() => ({ loaded: false }));
    }
  },
  mounted() {
    this.$http.get("/api/carousel/list")
      .then(
        response => {
          if(response.data.code == 200) {
            this.bannerImages = response.data.data.map(item => this.imgserver + item.imageUrl);
            // 初始化图片加载状态
            this.initImageLoadStates();
            // console.log(response, response.data.data.map(item => item.imageUrl))
          }
        }
      );
  }
};
</script>

<style lang="scss" scoped>
.swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
  height: 100%;
}
// 首页内层横向banner轮播
.banner-carousel {
  width: 100%;
  height: 100%;
  .inner-swiper {
    width: 100%;
    height: 100%;
    
    .image-container {
      width: 100%;
      height: 100%;
      position: relative;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        user-select: none;
        -webkit-user-drag: none;
        transition: opacity 0.3s ease;
      }
      
      .image-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        
        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid #ffffff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.banner-pagination {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10rem; // 调整与底部的距离
  width: 60%;
  margin: 0 auto;
}
// 进度条类型样式
.banner-pagination.swiper-pagination-progressbar {
  height: 4px; // 调整进度条高度
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}
.banner-pagination .swiper-pagination-progressbar-fill {
  background-color: #ffffff; // 进度条颜色
  border-radius: 2px;
}

// 底部“查看更多”滚动指示
.scroll-more {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  user-select: none;
  z-index: 2;
  .mouse {
    width: 24px;
    height: 36px;
    border: 2px solid rgba(255,255,255,0.9);
    border-radius: 20px;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    .dot {
      width: 6px;
      height: 8px;
      background: #fff;
      border-radius: 50%;
      margin-top: 8px;
      opacity: 1;
      animation: dot-slide 1.8s ease-in-out infinite;
    }
  }
  .label {
    margin-top: 10px;
    font-size: 12px;
    letter-spacing: 1px;
    color: rgba(255,255,255,0.9);
  }
}

@keyframes dot-slide {
  0% { transform: translateY(0); opacity: 1; }
  60% { transform: translateY(12px); opacity: 0; }
  61% { transform: translateY(0); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}
</style>